import {
  AssetTypes,
  EducationLevel,
  ExperienceLevel,
  Gender,
  IdTypes,
  OccupationGroup,
  PaymentMethods,
  SaleInterestPayoutPeriod
} from "../../backend/types/utils";
import i18n from "../../services/i18n";
import { defaultCountryAutocompleteOption } from "../../utils/utility";
import { countryList } from "./countryList";

const CountriesOptions = (): any => {
  let options = countryList("eu");
  options.push(defaultCountryAutocompleteOption);
  return options;
};

export const AutocompleteOptions = () => {
  return {
    countries: CountriesOptions(),
    educationLevel: [
      {
        label: i18n.t("Primary education"),
        code: EducationLevel.PRIMARY_EDUCATION
      },
      {
        label: i18n.t("Secondary education"),
        code: EducationLevel.SECONDARY_EDUCATION
      },
      {
        label: i18n.t("Academic degree"),
        code: EducationLevel.ACADEMIC_DEGREE
      },
      {
        label: i18n.t("Professional development"),
        code: EducationLevel.PROFESSIONAL_DEVELOPMENT
      },
      {
        label: i18n.t("Other"),
        code: EducationLevel.OTHER
      },
    ],
    occupationGroup: [
      {
        label: i18n.t("Employee"),
        code: OccupationGroup.EMPLOYEE
      },
      {
        label: i18n.t("Civil servant"),
        code: OccupationGroup.CIVIL_SERVANT
      },
      {
        label: i18n.t("Self-employed"),
        code: OccupationGroup.SELF_EMPLOYED
      },
      {
        label: i18n.t("Student"),
        code: OccupationGroup.STUDENT
      },
      {
        label: i18n.t("Pensioner"),
        code: OccupationGroup.PENSIONER
      },
      {
        label: i18n.t("Apprentice"),
        code: OccupationGroup.APPRENTICE
      },
      {
        label: i18n.t("Privatier"),
        code: OccupationGroup.PRIVATIER
      },
    ],
  };
};

export const SelectOptions = () => {
  return {
    asset: [
      {
        label: i18n.t("Real Estate"),
        value: AssetTypes.REAL_ESTATE
      },
      {
        label: i18n.t("Loan"),
        value: AssetTypes.LOAN
      },
    ],
    experience: [
      {
        label: i18n.t("Non"),
        value: ExperienceLevel.NONE
      },
      {
        label: i18n.t("Up to 3 years"),
        value: ExperienceLevel.LOW
      },
      {
        label: i18n.t("3 to 5 years"),
        value: ExperienceLevel.MEDIUM
      },
      {
        label: i18n.t("More than 5 years"),
        value: ExperienceLevel.HIGH
      },
    ],
    gender: [
      {
        label: i18n.t("Male"),
        value: Gender.MALE
      },
      {
        label: i18n.t("Female"),
        value: Gender.FEMALE
      },
    ],
    idDocumentType: [
      {
        label: i18n.t("ID"),
        value: IdTypes.ID
      },
      {
        label: i18n.t("Passport"),
        value: IdTypes.PASSPORT
      },
    ],
    increaseLimit: [
      {
        label: i18n.t("10% of available cash"),
        value: 1,
        id: "availableCash"
      },
      {
        label: i18n.t("Double of monthly NET salary"),
        value: 2,
        id: "monthlySalary"
      },
    ],
    paymentMethod: [
      {
        label: i18n.t("Credit Card"),
        value: PaymentMethods.CREDIT_CARD,
        disabled: true
      },
      {
        label: i18n.t("SEPA Direct Debit"),
        value: PaymentMethods.SEPA_DIRECT_DEBIT,
        disabled: true
      },
      {
        label: i18n.t("Wire Transfer"),
        value: PaymentMethods.WIRE_TRANSFER
      },
    ],
    period: [
      {
        label: i18n.t("Quarterly"),
        value: SaleInterestPayoutPeriod.QUARTERLY
      },
      {
        label: i18n.t("Semi-Annually"),
        value: SaleInterestPayoutPeriod.BIANNUAL
      },
      {
        label: i18n.t("Annually"),
        value: SaleInterestPayoutPeriod.YEARLY
      },
    ],
    yesNo: [
      {
        label: i18n.t("Yes"),
        value: true
      },
      {
        label: i18n.t("No"),
        value: false
      },
    ],
  };
};
